import MoveForwardIcon from '@mui/icons-material/ArrowForwardIos';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

import { styles } from '../styles/navigationArrows.styles';

const NavigationArrows = ({
	handlePrev,
	handleNext,
	className,
	hideBackButton = false,
	isNextDisabled,
	isBackDisabled,
	isNavigating
}) => {
	return (
		<Grid item sx={{ ...styles.arrows, ...className }}>
			{!hideBackButton && (
				<Button
					color="primary"
					variant="outlined"
					sx={styles.backButton}
					onClick={handlePrev}
					disabled={isBackDisabled}
				>
					<MoveForwardIcon sx={styles.backIcon} /> Back
				</Button>
			)}
			<Button
				color="primary"
				variant="contained"
				sx={styles.forwardButton}
				onClick={handleNext}
				disabled={isNextDisabled}
			>
				Next <MoveForwardIcon />
			</Button>
			{isNavigating && <CircularProgress size={21} sx={styles.loadingIcon} />}
		</Grid>
	);
};

export default NavigationArrows;
